<template>
    <div>
        <div v-if="enviar_correo === false">
            <vs-row>
                <vs-col lg="10">
                    <h5>{{info.subject}}</h5>
                </vs-col>
                <vs-col lg="2" class="d-flex text-center">
                    <div @click="enviar_correo = true" style="cursor:pointer">
                        <i class="fas fa-share-square mr-2" ></i> Reenviar
                    </div>
                </vs-col>
            </vs-row>
            <md-divider class="mt-3 mb-4"></md-divider>
            <vs-row>
                <vs-col>
                    <vs-row>
                        <vs-col lg="1">
                            <vs-avatar success class="m-auto">
                                <template #text>
                                    {{info.jobs[0].from_name}}
                                </template>
                            </vs-avatar>
                        </vs-col>
                        <vs-col lg="7">
                            <h6><span style="text-transform: capitalize;">{{info.jobs[0].from_name}}</span></h6>
                            <p class="mb-0">De: {{info.jobs[0].from_address}}</p>
                        </vs-col>
                        <vs-col lg="4" style="text-align: right">
                            {{ getDate(info.jobs[0].updated_at) }}
                        </vs-col>
                    </vs-row>
                </vs-col>
                <vs-col class="d-flex mt-2">
                    <div v-for="(file, index) in info.attachments" :key="index">
                        <archivosMail :file="file"></archivosMail>
                    </div>
                </vs-col>
                <vs-col class="mt-5">
                    <div v-html="info.body"></div>
                </vs-col>
            </vs-row>
            <md-divider class="mt-4 mb-4"></md-divider>
           
            <md-divider class="mt-4 mb-4"></md-divider>
            <vs-row class="pt-3 pb-3">
                <vs-col class="widthCard">
                    <md-card class="md-success">
                        <md-ripple class="text-center">
                            <md-card-header>
                            <div class="md-title">
                                <h2 class="mb-0">{{open}}</h2>
                            </div>
                            </md-card-header>

                            <md-card-content>
                                Leídos
                            </md-card-content>
                        </md-ripple>
                    </md-card>
                </vs-col>
                <vs-col class="widthCard">
                    <md-card class="md-warning">
                        <md-ripple class="text-center">
                            <md-card-header>
                            <div class="md-title">
                                <h2 class="mb-0">{{entregado}}</h2>    
                            </div>
                            </md-card-header>

                            <md-card-content>
                                Entregados
                            </md-card-content>
                        </md-ripple>
                    </md-card>
                </vs-col>
                <vs-col class="widthCard">
                    <md-card class="md-primary">
                        <md-ripple class="text-center">
                            <md-card-header>
                            <div class="md-title">
                                <h2 class="mb-0">{{processed}}</h2>
                            </div>
                            </md-card-header>

                            <md-card-content>
                                Proceso de envío
                            </md-card-content>
                        </md-ripple>
                    </md-card>
                </vs-col>
                <vs-col class="widthCard">
                    <md-card class="md-dark">
                        <md-ripple class="text-center">
                            <md-card-header>
                            <div class="md-title">
                                <h2 class="mb-0">{{rejected}}</h2>
                            </div>
                            </md-card-header>

                            <md-card-content>
                                Email no entregados
                            </md-card-content>
                        </md-ripple>
                    </md-card>
                </vs-col>
                <vs-col class="widthCard">
                    <md-card class="md-danger">
                        <md-ripple class="text-center">
                            <md-card-header>
                            <div class="md-title">
                                <h2 class="mb-0">{{spam}}</h2>
                            </div>
                            </md-card-header>

                            <md-card-content>
                                Spam
                            </md-card-content>
                        </md-ripple>
                    </md-card>
                </vs-col>
                <vs-col class="widthCard">
                    <md-card class="md-purple">
                        <md-ripple class="text-center">
                            <md-card-header>
                            <div class="md-title">
                                <h2 class="mb-0">{{unsubscribe}}</h2>
                            </div>
                            </md-card-header>

                            <md-card-content>
                                Desuscritos
                            </md-card-content>
                        </md-ripple>
                    </md-card>
                </vs-col>
            </vs-row>
            <vs-row class="mt-3">
                <vs-input v-model="search" border placeholder="Buscar" />
                <vs-col lg="4" v-for="(destino, n) in $vs.getSearch(info.jobs[0].sendedmails, search)" :key="n">
                    <vs-row class="p-3">
                        <vs-col lg="3">
                            <vs-avatar v-if="destino.avatar === ''" circle>
                                <template #text>
                                    {{destino.nombre}}
                                </template>
                            </vs-avatar>
                            <vs-avatar v-else circle>
                                <img :src="destino.avatar" :alt="destino.nombre">
                            </vs-avatar>
                        </vs-col>
                        <vs-col lg="9">
                            <p class="mb-0"><strong>{{destino.to_name}}</strong></p>
                            <p class="mb-0" style="overflow-wrap: break-word;">{{destino.to_address}}</p>
                            <md-chip class="mb-1 fontMedium mini-chip" :class="getStatus(destino.status)"><strong> {{ getEvent(destino.status) }} </strong></md-chip>
                        </vs-col>
                    </vs-row>
                </vs-col>
            </vs-row>
        </div>
        
        <reenviar v-if="enviar_correo" :info="info" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getRefreshTable()"></reenviar>
    </div>
</template>

<script>
import reenviar from './correo-reenviar.vue'
import archivosMail from './archivos_mail.vue'
export default {
    props: [
      'info',
      'institucion',
      'cicloEscolar',
    ],
    data(){
        return{
            search: '',
            general: {
                "estadisticas": {
                    "leido": "1234",
                    "entregado": "4586",
                    "proceso_envio": "528",
                    "email_invalido": "16",
                    "spam": "3"
                },
                "destinatarios": [
                    {
                        "nombre": "Juanito López",
                        "avatar": "",
                        "correo": "juanito.lopez@maristas.edu.mx",
                        "status": "Leído"
                    },
                    {
                        "nombre": "Marta Herrera",
                        "avatar": "https://vuesax.com/avatars/avatar-1.png",
                        "correo": "marta.herrera@maristas.edu.mx",
                        "status": "En proceso"
                    },
                    {
                        "nombre": "Alexis Castro",
                        "avatar": "",
                        "correo": "alexis.castro@maristas.edu.mx",
                        "status": "Spam"
                    },
                    {
                        "nombre": "Luis García",
                        "avatar": "https://vuesax.com/avatars/avatar-2.png",
                        "correo": "luis.garcia@maristas.com",
                        "status": "Email invalido"
                    },
                    {
                        "nombre": "Aimeé Salazar",
                        "avatar": "",
                        "correo": "aimee.salazar@maristas.edu.mx",
                        "status": "Entregado"
                    }
                ]
            },
            colorStatus: {
                "Leído": "green",
                "En proceso": "blue",
                "Email invalido": "black",
                "Spam": "red",
                "Entregado": "yellow"
            },
            enviar_correo: false,
            dictionary: {
                "processed": "Proceso de envío",
                "dropped": "Correo no entregado",
                "deferred": "Correo no entregado",
                "bounce": "Correo no entregado",
                "delivered": "Entregado",
                "open": "Leído",
                "click": "Leído",
                "spamreport": "Spam",
                "unsubscribe": "Desuscrito",
                "group_unsubscribe": "Desuscrito",
                "waiting": "Proceso de envío"
            },
            colorStatus: {
                "processed": "blue",
                "waiting": "blue",
                "dropped": "black",
                "deferred": "black",
                "bounce": "black",
                "delivered": "yellow",
                "open": "green",
                "click": "green",
                "spamreport": "red",
                "unsubscribe": "purple",
                "group_unsubscribe": "purple"
            },
            entregado: 0,
            open: 0,
            spam: 0,
            rejected: 0,
            processed: 0,
            unsubscribe: 0,
            loadingArchivo: true,
        }
    },
    components:{
        reenviar,
        archivosMail
    },
    created(){
        this.getEvents()
    },
    methods: {
        getRefreshTable(){
            this.$emit('refreshTable', true);
        },
        getStatus(status){
            return `col-${this.colorStatus[status]}`
        },
        getEvent(evento){
            return this.dictionary[evento]
        },
        getDate(info){
            if(info){
                const f = new Date(info);
                const result = f.toLocaleString();
                return result
            }
        },
        getEvents(){
            // const valor = this.info.sendedmails
            console.log("entro")
            const valor = this.info.jobs[0].sendedmails
            let proccess = 0
            let dropp = 0
            let deliver = 0
            let deferr = 0
            let bounce = 0
            let open = 0
            let click = 0
            let spamreport = 0
            let unsubscribe = 0
            let groupUnsubscribe = 0
            let waiting = 0
            valor.forEach(i => {
                if(i.status === 'processed'){
                    proccess = proccess + 1
                }
                if(i.status === 'waiting'){
                    waiting = waiting + 1
                }
                if(i.status === 'dropped'){
                    dropp = dropp + 1
                }
                if(i.status === 'deferred'){
                    deferr = deferr + 1
                }
                if(i.status === 'bounce'){
                    bounce = bounce + 1
                }
                if(i.status === 'delivered'){
                    deliver = deliver + 1
                }
                if(i.status === 'open'){
                    open = open + 1
                }
                if(i.status === 'click'){
                    click = click + 1
                }
                if(i.status === 'spamreport'){
                    spamreport = spamreport + 1
                }
                if(i.status === 'unsubscribe'){
                    unsubscribe = unsubscribe + 1
                }
                if(i.status === 'group_unsubscribe'){
                    groupUnsubscribe = groupUnsubscribe + 1
                }
                this.open = open + click
                this.spam = spamreport
                this.entregado = deliver
                this.rejected = dropp + deferr + bounce
                this.processed = proccess + waiting
                this.unsubscribe = unsubscribe + groupUnsubscribe
            })
        }
    },
    watch:{
        info(){
            this.getEvents()
        }
    }
}
</script>

<style scoped>
    .objetfitcover > img{
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 15px;
    }
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }

    .col-brown{
        color: #fff;
        background: rgb(0, 0, 0);
    }
    .mini-chip{
        width: 100% !important;
        text-align: center !important;
        height: 24px;
        line-height: 24px;
    }
</style>

<style>
.md-warn{
    background: #ffbc34;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 30%;
    margin: 1% 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-success{
    background: #5cb85c !important;
    color: white !important;
    border-radius: 7px;
}

.md-warning{
    background: #f0ad4e !important;
    color: white !important;
    border-radius: 7px;
}

.md-primary{
    background: #5bc0de !important;
    color: white !important;
    border-radius: 7px;
}

.md-danger{
    background: #f62d51 !important;
    color: white !important;
    border-radius: 7px;
}

.md-dark{
    background: #19191a !important;
    color: white !important;
    border-radius: 7px;
}
</style>